// extracted by mini-css-extract-plugin
export default {"root":"CandidateQuestionnaire_root__96SJP","icon":"CandidateQuestionnaire_icon__rWH17"};